import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ConfirmationService } from '@openng/optimus-ui/api';
import { IMG_LOC } from 'src/app/constants/common.constants';
import { TabService } from 'src/app/core/services/tab.service';
import { BreadCrumbBuilderService } from 'src/app/services/builder/breadcrumb-builder.service';
import { DeviceService } from 'src/app/services/device.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { ProgressSpinnerComponent } from '../../core/components/progress-spinner.component';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { AuthApiService } from 'src/app/services/api/auth-api.service';
import { CLAIMS } from 'src/app/constants/auth-constants';

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProgressSpinnerComponent, ButtonDirective, TranslatePipe],
})
export class MainContainerComponent implements OnInit {
  protected _breadCrumbService = inject(BreadCrumbBuilderService);
  protected _confirm = inject(ConfirmationService);
  protected _deviceService = inject(DeviceService);
  protected _translateService = inject(TranslateService);
  protected _authApi = inject(AuthApiService);
  protected _tabService = inject(TabService);

  tcEnergyImg: string = IMG_LOC + 'tc logo transparent.png';
  loadingGoTo: boolean = false;
  canViewManagerNote = false;

  ngOnInit() {
    this._breadCrumbService.clearBreadCrumbs();
    this.canViewManagerNote = this._authApi.doesUserHaveAllClaimsFromList([
      CLAIMS.MANAGER.VIEW_HOMEPAGE_NOTE,
    ]);
  }

  isMobile(): boolean {
    return this._deviceService.isMobile();
  }

  closeAllTabs(): void {
    const unsaved$ = this._translateService.get(
      'COMMON.MESSAGES.CONFIRMATION.CLOSE_ALL_TAB_MGS'
    );
    const yes$ = this._translateService.get('COMMON.LABEL.BUTTONS.YES');
    const no$ = this._translateService.get('COMMON.LABEL.BUTTONS.NO');
    const header$ = this._translateService.get(
      'COMMON.MESSAGES.HEADERS.CLOSE_TABS'
    );
    forkJoin([unsaved$, yes$, no$, header$]).subscribe((messages) => {
      this._confirm.confirm({
        header: messages[3],
        icon: 'fa fa-question-circle',
        acceptVisible: true,
        rejectVisible: true,
        acceptLabel: messages[1],
        rejectLabel: messages[2],
        message: messages[0],
        accept: () => {
          this._tabService.closeTab(-1, true);
        },
        reject: () => {},
      });
    });
  }
}
